<template>
    <el-dialog v-model="visible"
               title="发送邮件"
               width="600px"
               top="8vh"
               :close-on-click-modal="false"
               append-to-body>
        <el-form label-width="80px">
            <el-form-item label="发件人" required>
                <el-select v-model="accountid" placeholder="请选择发件账号" style="width:100%" filterable>
                    <el-option v-for="acc in accounts"
                               :key="acc.id"
                               :value="acc.id"
                               :label="acc.accountname || acc.from_email">
                        <div class="acc-option">
                            <span class="acc-name">{{ acc.accountname || acc.from_email }}</span>
                            <span v-if="acc.from_email" class="acc-mail">{{ acc.from_email }}</span>
                        </div>
                    </el-option>
                </el-select>
                <div v-if="!accounts.length" class="empty-tip">
                    暂无可用发件账号，请先到 设置-个人信息 中配置邮箱账号。
                </div>
            </el-form-item>
            <el-form-item label="收件人" required>
                <el-input v-model="form.to" placeholder="支持多个收件人，用逗号分隔" />
            </el-form-item>
            <el-form-item label="主题" required>
                <el-input v-model="form.subject" />
            </el-form-item>
            <el-form-item label="正文">
                <el-input v-model="form.body" type="textarea" :rows="7" />
            </el-form-item>
            <el-form-item label="附件">
                <span class="attachment-name">{{ filename }}</span>
            </el-form-item>
        </el-form>
        <template #footer>
            <el-button @click="visible = false">取消</el-button>
            <el-button type="primary" :loading="sending" @click="sendMail">发送</el-button>
        </template>
    </el-dialog>
</template>

<script>
    import { h } from 'vue';
    import { post } from '@/api';
    import { ElMessage, ElMessageBox } from 'element-plus';

    export default {
        name: 'SendMail',
        data() {
            return {
                visible: false,
                sending: false,
                accounts: [],
                accountid: null,
                filename: '',
                blob: null,
                companyid: 0,
                contactid: null,
                documentid: 0,
                doctype: 0,
                opportunityid: 0,
                form: {
                    to: '',
                    subject: '',
                    body: '',
                },
            };
        },
        methods: {
            // 由父组件通过 ref 调用打开，内部维护状态，不依赖 props
            async open({ recipient, subject, filename, blob, companyid, contactid, documentid, doctype, opportunityid }) {
                this.form.to = recipient || '';
                this.form.subject = subject || '';
                this.filename = filename || '';
                this.blob = blob || null;
                this.companyid = companyid || 0;
                this.contactid = contactid || null;
                this.documentid = documentid || 0;
                this.doctype = doctype || 0;
                this.opportunityid = opportunityid || 0;
                this.form.body = this.defaultBody();
                this.visible = true;
                await this.fetchAccounts();
            },
            defaultBody() {
                return 'Dear Sir/Madam,\n\nPlease find the attached document. Should you have any questions, please do not hesitate to contact us.\n\nBest regards,';
            },
            async fetchAccounts() {
                this.accounts = [];
                this.accountid = null;
                try {
                    const res = await post('mail.asp', { action: 'email_accounts' });
                    const list = (res && res.data) || [];
                    this.accounts = Array.isArray(list) ? list : [];
                    const def = this.accounts.find(a => Number(a.is_default) === 1);
                    this.accountid = def ? def.id : (this.accounts.length ? this.accounts[0].id : null);
                    if (!this.accounts.length) {
                        ElMessage.warning('暂无可用发件账号，请先到 设置-个人信息 中配置邮箱账号。');
                    }
                } catch (e) {
                    console.error('fetchAccounts error:', e);
                    ElMessage.error('获取发件账号失败');
                }
            },
            async sendMail() {
                if (!this.accountid) {
                    ElMessage.error('请选择发件账号');
                    return;
                }
                if (!this.form.to.trim()) {
                    ElMessage.error('请填写收件人');
                    return;
                }
                if (!this.form.subject.trim()) {
                    ElMessage.error('请填写主题');
                    return;
                }
                if (!this.blob) {
                    ElMessage.error('附件缺失，请重新打开发送');
                    return;
                }
                // 发送前二次确认（Email 监管）：展示发件人/收件人/主题
                const acc = this.accounts.find(a => Number(a.id) === Number(this.accountid));
                const fromLabel = acc ? (acc.accountname || acc.from_email) : '已选账号';
                const confirmMsg = h('div', { style: 'line-height:1.9;font-size:14px;color:#303133' }, [
                    h('div', null, [h('span', { style: 'color:#909399;margin-right:4px' }, '发件人：'), fromLabel]),
                    h('div', null, [h('span', { style: 'color:#909399;margin-right:4px' }, '收件人：'), this.form.to.trim()]),
                    h('div', null, [h('span', { style: 'color:#909399;margin-right:4px' }, '主题：'), this.form.subject.trim()]),
                ]);
                try {
                    await ElMessageBox.confirm(confirmMsg, '确认发送邮件', {
                        confirmButtonText: '确认发送',
                        cancelButtonText: '取消',
                        type: 'warning',
                    });
                } catch (e) {
                    return; // 用户取消，不发送
                }
                this.sending = true;
                try {
                    const base64 = await this.blobToBase64(this.blob);
                    const payload = {
                        action: 'send',
                        accountid: this.accountid,
                        to: this.form.to.trim(),
                        subject: this.form.subject.trim(),
                        body: this.form.body,
                        attachment_base64: base64,
                        attachment_name: this.filename,
                        companyid: this.companyid,
                        documentid: this.documentid,
                        doctype: this.doctype,
                        opportunityid: this.opportunityid,
                    };
                    if (this.contactid) payload.contactid = this.contactid;
                    const res = await post('mail.asp', payload);
                    if (res && res.success) {
                        ElMessage.success((res.message && String(res.message)) || '邮件发送成功');
                        this.visible = false;
                    } else {
                        ElMessage.error((res && res.error) || '发送失败');
                    }
                } catch (e) {
                    console.error('sendMail error:', e);
                    ElMessage.error('发送失败');
                } finally {
                    this.sending = false;
                }
            },
            blobToBase64(blob) {
                return new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.onload = () => {
                        const result = reader.result || '';
                        resolve(String(result).split(',')[1] || '');
                    };
                    reader.onerror = () => reject(reader.error);
                    reader.readAsDataURL(blob);
                });
            },
        },
    };
</script>

<style scoped>
    .acc-option {
        display: flex;
        flex-direction: column;
        line-height: 1.3;
    }

    .acc-name {
        font-weight: 500;
    }

    .acc-mail {
        font-size: 12px;
        color: #909399;
    }

    .empty-tip {
        margin-top: 6px;
        font-size: 12px;
        color: #e6a23c;
        line-height: 1.4;
    }

    .attachment-name {
        font-size: 13px;
        color: #303133;
        word-break: break-all;
    }
</style>
